/* ==========================================================================
   FRÈRES — Mundial · "Hacelo llorar" (juego contra reloj + ranking)
   Config vía window.FR_MUNDIAL = { faces:[4 urls], dbUrl, seconds }
   El ranking usa la REST API de Realtime Database (nodo público /mundial).
   ========================================================================== */
(() => {
  'use strict';
  const root = document.querySelector('.frm-root');
  if (!root) return;

  const CFG = window.FR_MUNDIAL || {};
  const FACES = CFG.faces || [];
  const DB = (CFG.dbUrl || '').replace(/\/$/, '');
  const RUN_SECONDS = CFG.seconds || 30;

  const $ = s => root.querySelector(s);
  const fmt = n => Number(n).toLocaleString('es-AR');

  const countEl = $('[data-frm-count]');
  const timerEl = $('[data-frm-timer]');
  const multEl  = $('[data-frm-mult]');
  const cv      = $('[data-frm-canvas]');
  const ctx     = cv.getContext('2d');
  const wrap    = $('[data-frm-cv-wrap]');

  /* ===== estado de partida ===== */
  let running = false, ended = false, timeLeft = RUN_SECONDS, runScore = 0;
  let best = parseInt(localStorage.getItem('fr-mundial-best') || '0', 10) || 0;
  let myName = localStorage.getItem('fr-mundial-name') || '';

  const renderCount = () => { countEl.textContent = fmt(runScore); };
  const fmtTime = s => { s = Math.max(0, Math.ceil(s)); return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0'); };
  const updateTimer = () => { timerEl.textContent = '⏱ ' + fmtTime(timeLeft); timerEl.classList.toggle('is-low', timeLeft <= 10); };

  /* ===== intensidad reactiva (heat) → cara ===== */
  let heat = 0, faceStage = 0, lastTs = null;
  const HIT_ADD = 16, HEAT_MAX = 100, DECAY = 0.032;
  const UP = [12, 34, 66], DOWN = [8, 28, 58];
  function updateFace() {
    while (faceStage < 3 && heat >= UP[faceStage]) faceStage++;
    while (faceStage > 0 && heat < DOWN[faceStage - 1]) faceStage--;
  }

  /* ===== caras (recorte de fondo blanco) ===== */
  const PW = 280, PH = 280;
  const frames = [null, null, null, null];
  let framesReady = 0;
  function process(image) {
    const pc = document.createElement('canvas'); pc.width = PW; pc.height = PH;
    const c = pc.getContext('2d'); c.drawImage(image, 0, 0, PW, PH);
    const id = c.getImageData(0, 0, PW, PH), d = id.data;
    const seen = new Uint8Array(PW * PH), stack = [];
    const white = i => d[i] > 220 && d[i + 1] > 220 && d[i + 2] > 220 &&
      (Math.max(d[i], d[i + 1], d[i + 2]) - Math.min(d[i], d[i + 1], d[i + 2])) < 22;
    const push = (x, y) => {
      if (x < 0 || y < 0 || x >= PW || y >= PH) return;
      const p = y * PW + x; if (seen[p]) return; seen[p] = 1; if (white(p * 4)) stack.push(p);
    };
    for (let x = 0; x < PW; x++) { push(x, 0); push(x, PH - 1); }
    for (let y = 0; y < PH; y++) { push(0, y); push(PW - 1, y); }
    while (stack.length) {
      const p = stack.pop(); d[p * 4 + 3] = 0;
      const x = p % PW, y = (p / PW) | 0;
      push(x - 1, y); push(x + 1, y); push(x, y - 1); push(x, y + 1);
    }
    c.putImageData(id, 0, 0); return pc;
  }
  FACES.forEach((src, i) => {
    const im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = () => { frames[i] = process(im); if (++framesReady === FACES.length) buildRoster(); };
    im.onerror = () => { if (++framesReady === FACES.length) buildRoster(); };
    im.src = src;
  });

  /* ===== efectos ===== */
  let drops = [];
  const spawnDrops = n => {
    for (let i = 0; i < n; i++) {
      const side = Math.random() < .5 ? -1 : 1;
      drops.push({ x: 240 + side * (30 + Math.random() * 40), y: 210,
        vx: side * (1 + Math.random() * 3), vy: -(3 + Math.random() * 6), life: 55 + Math.random() * 25 });
    }
  };
  let slap = null; const SLAP = 22;
  let shake = 0, squash = 0, lastMilestone = 0;
  let muted = false;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  let AC = null;
  const slapSound = () => {
    if (muted) return;
    try {
      AC = AC || new (window.AudioContext || window.webkitAudioContext)();
      const t = AC.currentTime;
      const buf = AC.createBuffer(1, AC.sampleRate * .09, AC.sampleRate);
      const dd = buf.getChannelData(0);
      for (let i = 0; i < dd.length; i++) dd[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / dd.length, 2.2);
      const s = AC.createBufferSource(); s.buffer = buf;
      const f = AC.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 900;
      const gn = AC.createGain(); gn.gain.setValueAtTime(.28, t); gn.gain.exponentialRampToValueAtTime(.01, t + .09);
      s.connect(f); f.connect(gn); gn.connect(AC.destination); s.start(t);
    } catch (e) {}
  };

  /* ===== samba de fondo (Web Audio, sin archivos) ===== */
  let sambaTimer = null, sambaStep = 0, sambaNext = 0, sambaMaster = null;
  const MUSIC_ON = false;   /* samba procedural apagada — se reemplaza por el MP3 real */
  const SUR = [0,0,0,0, 1,0,0,0, 2,0,0,0, 1,0,0,0];   /* surdo: acento en el "2" */
  const AGO = [1,0,1,2, 1,0,2,1, 1,0,1,2, 1,0,2,1];   /* agogô: 1=agudo 2=grave */
  const CAI = [2,1,2,1, 2,1,2,1, 2,1,2,1, 2,1,2,1];   /* caixa: semicorcheas */
  function surdo(t, acc) {
    const o = AC.createOscillator(), g = AC.createGain();
    o.type = 'sine'; o.frequency.setValueAtTime(105, t); o.frequency.exponentialRampToValueAtTime(52, t + .12);
    g.gain.setValueAtTime(acc ? .9 : .4, t); g.gain.exponentialRampToValueAtTime(.001, t + .22);
    o.connect(g); g.connect(sambaMaster); o.start(t); o.stop(t + .24);
  }
  function noiseHit(t, dur, freq, q, vol, hp) {
    const b = AC.createBuffer(1, Math.max(1, AC.sampleRate * dur), AC.sampleRate), d = b.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    const s = AC.createBufferSource(); s.buffer = b;
    const f = AC.createBiquadFilter(); f.type = hp ? 'highpass' : 'bandpass'; f.frequency.value = freq; f.Q.value = q;
    const g = AC.createGain(); g.gain.setValueAtTime(vol, t); g.gain.exponentialRampToValueAtTime(.001, t + dur);
    s.connect(f); f.connect(g); g.connect(sambaMaster); s.start(t);
  }
  function bell(t, hi) {
    const o = AC.createOscillator(), o2 = AC.createOscillator(), g = AC.createGain();
    o.type = 'square'; o2.type = 'sine';
    o.frequency.value = hi ? 1050 : 770; o2.frequency.value = hi ? 2080 : 1500;
    g.gain.setValueAtTime(.12, t); g.gain.exponentialRampToValueAtTime(.001, t + .11);
    o.connect(g); o2.connect(g); g.connect(sambaMaster); o.start(t); o2.start(t); o.stop(t + .12); o2.stop(t + .12);
  }
  function sambaTick() {
    const stepDur = 60 / 104 / 4;
    while (sambaNext < AC.currentTime + .12) {
      const t = sambaNext, s = sambaStep % 16;
      if (SUR[s]) surdo(t, SUR[s] === 2);
      if (AGO[s]) bell(t, AGO[s] === 1);
      if (CAI[s]) noiseHit(t, .05, 2000, 1.2, CAI[s] === 2 ? .10 : .045, false);
      noiseHit(t, .03, 9000, .7, (s % 2 ? .025 : .045), true);
      sambaNext += stepDur; sambaStep++;
    }
  }
  function startSamba() {
    if (!MUSIC_ON || muted || sambaTimer) return;
    try {
      AC = AC || new (window.AudioContext || window.webkitAudioContext)();
      if (AC.state === 'suspended') AC.resume();
      if (!sambaMaster) { sambaMaster = AC.createGain(); sambaMaster.gain.value = .55; sambaMaster.connect(AC.destination); }
      sambaStep = 0; sambaNext = AC.currentTime + .06;
      sambaTick(); sambaTimer = setInterval(sambaTick, 25);
    } catch (e) {}
  }
  function stopSamba() { if (sambaTimer) { clearInterval(sambaTimer); sambaTimer = null; } }

  /* ===== música real (MP3 de samba) — pausa otros reproductores de la página ===== */
  let music = null, ducked = [], sitePill = null;
  function duckOthers() {
    ducked = [];
    document.querySelectorAll('audio, video').forEach(el => {
      if (el !== music && !el.paused) { try { el.pause(); ducked.push(el); } catch (e) {} }
    });
    /* reproductor Spotify del theme: si está sonando, tocamos su botón para pausarlo */
    const pill = document.querySelector('[data-sp-pill]');
    if (pill && pill.classList.contains('is-playing')) { try { pill.click(); sitePill = pill; } catch (e) {} }
  }
  function restoreOthers() {
    ducked.forEach(el => { try { el.play(); } catch (e) {} }); ducked = [];
    if (sitePill && !sitePill.classList.contains('is-playing')) { try { sitePill.click(); } catch (e) {} }
    sitePill = null;
  }
  function startMusic() {
    if (muted || !CFG.music) return;
    try {
      duckOthers();
      if (!music) { music = new Audio(CFG.music); music.loop = true; music.volume = .5; music.preload = 'auto'; }
      music.currentTime = 0; const p = music.play(); if (p && p.catch) p.catch(() => {});
    } catch (e) {}
  }
  function stopMusic() { if (music) { try { music.pause(); } catch (e) {} } restoreOthers(); }

  /* ===== dibujo ===== */
  function draw(t) {
    ctx.clearRect(0, 0, cv.width, cv.height);
    ctx.imageSmoothingEnabled = false;
    const st = faceStage;
    const bob = Math.sin(t / 620) * 3 + (st >= 3 ? Math.sin(t / 150) * 3 : 0);
    const ox = (Math.random() - .5) * shake * 4, oy = (Math.random() - .5) * shake * 4;
    ctx.save(); ctx.translate(ox, oy);
    const fr = frames[st] || frames[0];
    if (fr) {
      const TW = 468, TH = 468, cx = cv.width / 2, topy = 4 + bob, sc = Math.max(0, squash);
      ctx.save(); ctx.translate(cx, topy + TH / 2); ctx.scale(1 + sc * .06, 1 - sc * .06);
      ctx.drawImage(fr, -TW / 2, -TH / 2, TW, TH); ctx.restore();
    }
    if (slap) {
      ctx.fillStyle = 'rgba(232,80,60,' + (slap.t / SLAP * .5).toFixed(2) + ')';
      ctx.fillRect(slap.side < 0 ? 150 : 300, 190, 34, 30);
    }
    for (const d of drops) { ctx.fillStyle = '#9FD8EF'; ctx.fillRect(d.x, d.y, 8, 8); ctx.fillStyle = '#D3F0FB'; ctx.fillRect(d.x, d.y, 4, 4); }
    if (slap && slap.t > SLAP * .45) {
      const prog = Math.min(1, (SLAP - slap.t) / (SLAP * .5));
      const tx = slap.side < 0 ? 165 : 315, fx = slap.side < 0 ? -70 : 550;
      const gx = fx + (tx - fx) * prog, gy = 205;
      ctx.fillStyle = '#F5F1EA'; ctx.fillRect(gx - 30, gy - 22, 60, 44);
      ctx.fillStyle = '#C9C2B4'; ctx.fillRect(gx - 30, gy + 14, 60, 8);
      ctx.fillStyle = '#F5F1EA'; ctx.fillRect(gx + (slap.side < 0 ? 24 : -32), gy - 26, 10, 12);
      ctx.strokeStyle = '#000'; ctx.lineWidth = 3; ctx.strokeRect(gx - 30, gy - 22, 60, 44);
      ctx.fillStyle = '#000';
      for (let i = 0; i < 3; i++) ctx.fillRect(gx + (slap.side < 0 ? -46 - i * 10 : 34 + i * 10), gy - 8 + i * 8, 14, 3);
    }
    if (slap && slap.t >= SLAP * .35 && slap.t <= SLAP * .62) {
      const sx = slap.side < 0 ? 168 : 312, sy = 200;
      ctx.fillStyle = '#F2C744';
      ctx.fillRect(sx - 3, sy - 18, 8, 8); ctx.fillRect(sx - 3, sy + 12, 8, 8);
      ctx.fillRect(sx - 18, sy - 3, 8, 8); ctx.fillRect(sx + 12, sy - 3, 8, 8);
      ctx.fillStyle = '#FFF'; ctx.fillRect(sx - 4, sy - 4, 10, 10);
    }
    ctx.restore();
  }

  let t0 = null;
  function loop(ts) {
    t0 = t0 || ts; const t = ts - t0;
    const dt = lastTs == null ? 16 : Math.min(60, ts - lastTs); lastTs = ts;
    heat = Math.max(0, heat - dt * DECAY); updateFace();
    if (running) { timeLeft -= dt / 1000; if (timeLeft <= 0) { timeLeft = 0; endRun(); } updateTimer(); }
    if (slap) { slap.t--; if (slap.t <= 0) slap = null; }
    squash *= .82; shake *= .8;
    drops = drops.filter(d => (d.life-- > 0 && d.y < 620));
    for (const d of drops) { d.x += d.vx; d.y += d.vy; d.vy += .5; }
    draw(t); requestAnimationFrame(loop);
  }
  requestAnimationFrame(loop);

  /* ===== interacción ===== */
  const tierEls = [...root.querySelectorAll('[data-frm-goal]')];
  function refreshTiers() {
    for (const el of tierEls) if (runScore >= +el.dataset.frmGoal) el.classList.add('is-unlocked');
  }
  function banner(msg) {
    const b = document.createElement('div'); b.className = 'frm-banner'; b.textContent = msg;
    document.body.appendChild(b); setTimeout(() => b.remove(), 2700);
  }
  function hit(ev) {
    ev.preventDefault();
    if (ended) return;
    if (!running) { running = true; startMusic(); }
    heat = Math.min(HEAT_MAX, heat + HIT_ADD); updateFace();
    const mult = [1, 2, 3, 4][faceStage];
    runScore += mult; renderCount();
    multEl.textContent = mult > 1 ? 'x' + mult : '';
    slap = { t: SLAP, side: Math.random() < .5 ? -1 : 1 };
    squash = 1; if (!reduced) shake = 5;
    spawnDrops(faceStage >= 2 ? 6 : 3); slapSound();
    const pop = document.createElement('div'); pop.className = 'frm-pop'; pop.textContent = '+' + mult;
    const wr = wrap.getBoundingClientRect();
    const cx = ev.touches ? ev.touches[0].clientX : ev.clientX;
    const cy = ev.touches ? ev.touches[0].clientY : ev.clientY;
    pop.style.left = (cx - wr.left - 8) + 'px'; pop.style.top = (cy - wr.top - 14) + 'px';
    wrap.appendChild(pop); setTimeout(() => pop.remove(), 850);
    for (const el of tierEls) {
      const g = +el.dataset.frmGoal;
      if (runScore >= g && g > lastMilestone) {
        lastMilestone = g;
        const label = (el.querySelector('.frm-d') || {}).textContent || 'un premio';
        banner('¡Desbloqueaste ' + label + '!');
      }
    }
    refreshTiers();
  }
  cv.addEventListener('pointerdown', hit);

  /* ===== fin de partida + ranking ===== */
  const overEl = $('[data-frm-over]');
  const entryEl = $('[data-frm-entry]');
  const savedEl = $('[data-frm-saved]');
  const nameInput = $('[data-frm-name]');
  const finalEl = $('[data-frm-final]');
  const bestEl = $('[data-frm-best]');

  function endRun() {
    running = false; ended = true; stopMusic();
    if (runScore > best) { best = runScore; localStorage.setItem('fr-mundial-best', String(best)); }
    finalEl.textContent = fmt(runScore);
    bestEl.textContent = fmt(best);
    savedEl.hidden = true;
    entryEl.hidden = runScore <= 0;
    if (myName) nameInput.value = myName;
    overEl.hidden = false;
    if (runScore > 0) nameInput.focus();
  }

  const submitBtn = $('[data-frm-submit]');
  submitBtn && submitBtn.addEventListener('click', submitScore);
  nameInput && nameInput.addEventListener('keydown', e => { if (e.key === 'Enter') submitScore(); });

  async function submitScore() {
    const name = (nameInput.value || '').trim().slice(0, 16) || 'ANÓNIMO';
    myName = name; localStorage.setItem('fr-mundial-name', name);
    submitBtn.disabled = true; submitBtn.textContent = 'Guardando…';
    let ok = false;
    if (DB) {
      try {
        const r = await fetch(DB + '/mundial/scores.json', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name, score: runScore, ts: Date.now() })
        });
        ok = r.ok;
      } catch (e) { ok = false; }
    }
    entryEl.hidden = true;
    savedEl.hidden = false;
    savedEl.textContent = ok ? '¡Estás en el ranking! 🏆' : 'El ranking se activa muy pronto — probá de nuevo en un rato.';
    submitBtn.disabled = false; submitBtn.textContent = 'Entrar al ranking';
    loadBoard();
  }

  /* ===== tablero ===== */
  const boardBody = $('[data-frm-board-body]');
  const SAMPLE = [['TOTO.C', 4812], ['NACHO_F', 3977], ['JUANI', 2410], ['RAMA.B', 1180], ['SOFI', 940]];
  function renderBoard(rows, live) {
    boardBody.innerHTML = '';
    rows.slice(0, 10).forEach((r, i) => {
      const tr = document.createElement('tr');
      if (myName && r[0] && r[0].toUpperCase() === myName.toUpperCase()) tr.className = 'is-me';
      if (i < 3) tr.classList.add('frm-r' + (i + 1));   /* oro / plata / bronce */
      const medal = ['🥇', '🥈', '🥉'][i];
      const td1 = document.createElement('td'); td1.textContent = (medal ? medal + ' ' : (i + 1) + '. ') + r[0];
      const td2 = document.createElement('td'); td2.className = 'frm-pts'; td2.textContent = fmt(r[1]);
      tr.appendChild(td1); tr.appendChild(td2); boardBody.appendChild(tr);
    });
    const note = root.querySelector('[data-frm-board-note]');
    if (note) note.textContent = live ? 'Ranking en vivo del Mundial.' : 'Ranking de ejemplo — se activa al conectar la base.';
  }
  async function loadBoard() {
    if (!DB) { renderBoard(SAMPLE, false); return; }
    try {
      const r = await fetch(DB + '/mundial/scores.json');
      if (!r.ok) throw new Error('rules');
      const data = await r.json();
      if (!data) { renderBoard([], true); return; }
      /* solo el mejor puntaje de cada jugador (dedup por nombre) */
      const best = {};
      Object.values(data).filter(v => v && typeof v.score === 'number').forEach(v => {
        const n = String(v.name || 'ANÓNIMO'), k = n.toUpperCase();
        if (!best[k] || v.score > best[k][1]) best[k] = [n, v.score];
      });
      const rows = Object.values(best).sort((a, b) => b[1] - a[1]);
      renderBoard(rows, true);
    } catch (e) {
      renderBoard(SAMPLE, false);
    }
  }
  loadBoard();

  /* ===== rearmar partida ===== */
  const replayBtn = $('[data-frm-replay]');
  replayBtn && replayBtn.addEventListener('click', () => {
    ended = false; running = false; timeLeft = RUN_SECONDS; runScore = 0;
    heat = 0; faceStage = 0; lastMilestone = 0; multEl.textContent = '';
    for (const el of tierEls) el.classList.remove('is-unlocked');
    overEl.hidden = true; renderCount(); updateTimer(); refreshTiers();
  });

  /* ===== mute ===== */
  const muteBtn = $('[data-frm-mute]');
  muteBtn && muteBtn.addEventListener('click', () => {
    muted = !muted; muteBtn.textContent = muted ? '🔇' : '🔊';
    muteBtn.setAttribute('aria-label', muted ? 'Activar sonido' : 'Silenciar');
    if (muted) stopMusic(); else if (running) startMusic();
  });

  /* ===== selector de rivales ===== */
  const roster = $('[data-frm-roster]');
  const RIVALS = [
    { name: 'Neymar', locked: false }, { name: 'Mbappé', locked: true },
    { name: 'CR7', locked: true }, { name: '???', locked: true }
  ];
  function buildRoster() {
    roster.innerHTML = '';
    for (const rv of RIVALS) {
      const d = document.createElement('div');
      d.className = 'frm-pick' + (rv.locked ? ' is-locked' : ' is-active');
      const c = document.createElement('canvas'); c.width = 64; c.height = 64;
      const cg = c.getContext('2d'); cg.imageSmoothingEnabled = false;
      if (!rv.locked && frames[0]) {
        cg.fillStyle = '#F5F1EA'; cg.fillRect(0, 0, 64, 64);
        cg.drawImage(frames[0], 10, 10, 260, 250, 0, 0, 64, 64);
      } else {
        cg.fillStyle = '#DDE4ED'; cg.fillRect(0, 0, 64, 64);
        cg.fillStyle = '#6B7A8C'; cg.fillRect(22, 12, 20, 18); cg.fillRect(14, 34, 36, 24);
        cg.fillStyle = '#F5F1EA'; cg.font = 'bold 20px monospace'; cg.fillText('?', 27, 30);
      }
      const s = document.createElement('span'); s.textContent = rv.locked ? rv.name + ' · pronto' : rv.name;
      d.appendChild(c); d.appendChild(s); roster.appendChild(d);
    }
  }
  buildRoster();

  renderCount(); updateTimer(); refreshTiers();
})();
